
<div class="row" *ngIf="round">
    <div class="col p-5">
        <h3 class="mb-4">{{ round.name }}</h3>

        <div class="row">
            <div class="col">
                <form [formGroup]="form" (submit)="save()" class="form">
                    <div class="row mb-3">
                        <div class="col-3">
                            <label for="wins_count">Кол-во побед</label>
                        </div>
                        <div class="col">
                            <input type="text" name="wins_count" id="wins_count" formControlName="wins_count">
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-3">
                            <label for="rating_score">Рейтинговые очки</label>
                        </div>
                        <div class="col">
                            <input type="text" name="rating_score" id="rating_score" formControlName="rating_score">
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-3">
                            <label for="place_from">Место от</label>
                        </div>
                        <div class="col">
                            <input type="text" name="place_from" id="place_from" formControlName="place_from">
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-3">
                            <label for="place_to">Место до</label>
                        </div>
                        <div class="col">
                            <input type="text" name="place_to" id="place_to" formControlName="place_to">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-3">
                            <label for="scheduled_at_date">Планируемые дата и время встреч:</label>
                        </div>
                        <div class="col-auto">
                            <input
                                type="text"
                                name="scheduled_at_date"
                                ngbDatepicker
                                #d="ngbDatepicker"
                                id="scheduled_at_date"
                                [(ngModel)]="scheduledAtDate"
                                [ngModelOptions]="{standalone: true}"
                                (click)="d.toggle()"
                            >
                        </div>
                        <div class="col">
                            <ngb-timepicker
                                [(ngModel)]="scheduledAtTime"
                                [spinners]="false"
                                [ngModelOptions]="{standalone: true}"
                                [size]="'small'"
                            ></ngb-timepicker>
                        </div>
                    </div>

                    <div class="form-group"><button type="submit" class="btn btn-primary btn-sm">Сохранить</button></div>
                </form>
            </div>
        </div>
    </div>
</div>